import { media } from "@/styles/media";
import { IFontProps } from "@/typings/Props";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

export default function KeyFeature({ ...props }) {
  const { t } = useTranslation();
  return (
    <KeyFeatureWrapper>
      <P id="title" $fontColor="#971b2f" $fontWeight="700" $fontSize="1.8rem" $marginTop="30px">
        {t(props.title)}
      </P>
      <Desc id="desc" $visibility="hidden">
        {t(props.desc)}
      </Desc>
      <Image id="img" $src={props.image} />
    </KeyFeatureWrapper>
  );
}

const KeyFeatureWrapper = styled.div`
  position: relative;
  width: calc(25% - 22.5px);
  height: 556px;
  overflow: hidden;
  background-color: white;
  border-radius: 10px;
  /* margin: 30px; */
  transition: 0.3s ease-out;
  &:hover {
    background-color: #971b2f;
    & > #title {
      color: white;
    }
    & > #desc {
      visibility: visible;
    }

    & > #img {
      opacity: 0.7;
      transition: 0.3s ease-out;
      transform: scale(1.2);
    }
  }

  ${media.desktop`
    width: calc(50% - 10px);
  `}

  ${media.tablet`
    width: 100%;
    margin: 20px 0 0 0;
  `}
`;
const P = styled.p<IFontProps>`
  color: ${(props) => props.$fontColor};
  font-weight: ${(props) => props.$fontWeight};
  font-size: ${(props) => props.$fontSize};
  margin-top: ${(props) => props.$marginTop};
  line-height: ${(props) => props.$lineHeight};
  visibility: ${(props) => (props.$visibility ? props.$visibility : "visible")};
  margin-left: 20px;
  padding: 10px;
  z-index: 999;

  &#title {
    min-height: 80px;
    white-space: pre-line;
  }
`;

const Desc = styled.p<{ $visibility: string }>`
  visibility: ${({ $visibility }) => ($visibility ? $visibility : "visible")};
  line-height: 150%;
  z-index: 999;
  padding: 0px 30px;
  color: white;
  white-space: pre-line;
`;

const Image = styled.div<{ $src: string }>`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 100%;
  transition: 0.3s ease-out;
  background-image: url(${({ $src }) => $src});
  background-repeat: no-repeat;
  background-position: bottom center;
  background-size: 100%;

  @media (max-width: 1000px) {
    height: 100%;
    background-position: 50% center;
  }
`;
